import { FC } from 'react';
import './settings.css';
import 'react-tabs/style/react-tabs.css';
import ResumeSkills from '../../components/resumeSkills';
import PasswordForm from '../../components/passwordForm';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PastJobPostingsAnalysis from '../../components/pastJobPostingsAnalysis';
import MembershipManagement from '../../components/membershipManagement';

const UserSettings: FC = () => {
    return (
        <Tabs>
            <TabList>
                <Tab>Resumes</Tab>
                <Tab>Password</Tab>
                <Tab>Job Posting Logs</Tab>
                <Tab>Membership</Tab>
            </TabList>

            <TabPanel>
                <ResumeSkills />
            </TabPanel>

            <TabPanel>
                <PasswordForm />
            </TabPanel>

            <TabPanel>
                <PastJobPostingsAnalysis />
            </TabPanel>

            <TabPanel>
                <MembershipManagement />
            </TabPanel>
        </Tabs>
    );
};

export default UserSettings;